import { createEntityAdapter } from '@reduxjs/toolkit';

import { AppError } from '@vk-hr-tek/core/error';

import { DynamicEntity } from '@app/types';

import { ExtendedCustomLinkItem } from '../types';

export interface UserSettingsState {
  userSection: {
    status: 'idle' | 'loading' | 'complete' | 'failed';
    name: string;
    menuItems: ExtendedCustomLinkItem[];
    error: AppError | null;
    needRefetch?: boolean;
  };
}

export const initialState: UserSettingsState = {
  userSection: {
    name: '',
    menuItems: [],
    status: 'idle',
    error: null,
    needRefetch: undefined,
  },
};

export const userSettingsAdapter = createEntityAdapter<DynamicEntity>();
